class ProductFixedBar extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)
    this.setVisibility = this.setVisibility.bind(this)

    this.setupObservers()
    this.updateEl()
  }

  setupObservers () {
    this.sectionObserver = new IntersectionObserver(this.onEntry.bind(this), {
      rootMargin: '-50%',
    })

    this.externalEls?.section?.elements.forEach((sectionEl) => {
      this.sectionObserver.observe(sectionEl)
    })

    this.formFooterObserver = new IntersectionObserver(
      ([entry]) => this.onFormFooterIntersection(entry),
      {
        rootMargin: '25%',
        threshold: 0,
      },
    )
    this.heroObserver = new IntersectionObserver(
      ([entry]) => this.onHeroIntersection(entry),
      {
        threshold: 0.5,
      },
    )
    this.pageFooterObserver = new IntersectionObserver(
      ([entry]) => this.onPageFooterIntersection(entry),
      {
        threshold: 0,
      },
    )

    if (this.externalEls?.form?.element) {
      this.formFooterObserver.observe(this.externalEls?.form?.element)
    }
    if (this.externalEls?.hero?.element) {
      this.heroObserver.observe(this.externalEls?.hero?.element)
    }
    if (this.externalEls?.footer?.element) {
      this.pageFooterObserver.observe(this.externalEls?.footer?.element)
    }
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)
    this.navigationEl = this.navigationEl.bind(this)
    this.externalNavigationEl = this.externalNavigationEl.bind(this)

    this.listeners.add(window, 'scroll', this.onScroll)

    this.els?.trigger?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.navigationEl)
    })

    this.externalEls?.trigger?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.externalNavigationEl)
    })
  }

  onEntry ([entry]) {
    if (!entry.isIntersecting) return

    const sectionEl = entry.target

    this.els.trigger.elements.forEach((triggerEl) => {
      triggerEl.setAttribute(
        'aria-current',
        triggerEl.dataset.section === sectionEl.dataset.section,
      )
    })
  }

  onFormFooterIntersection (entry) {
    this.setVisibility(!entry.isIntersecting)
  }

  onHeroIntersection (entry) {
    this.preventScroll = entry.isIntersecting
    this.setVisibility(!entry.isIntersecting)
  }

  onPageFooterIntersection (entry) {
    this.setVisibility(!entry.isIntersecting)
  }

  onScroll () {
    this.lastKnownY = window.scrollY
    this.requestTick()
  }

  navigationEl (event) {
    const currentEl = event.target.closest(this.els?.trigger?.selector)

    this.externalEls?.section?.elements.forEach((sectionEl) => {
      if (currentEl.dataset.section === sectionEl.dataset.section) {
        sectionEl.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }

      this.els?.trigger?.elements.forEach((tempEl) => {
        if (tempEl !== currentEl) {
          tempEl.setAttribute('aria-current', 'false')
        }
      })

      const currentState = currentEl.getAttribute('aria-current') === 'true'
      currentEl.setAttribute('aria-current', !currentState)
    })
  }

  externalNavigationEl (event) {
    const currentEl = event.target.closest(this.externalEls?.trigger?.selector)

    this.externalEls?.section?.elements.forEach((sectionEl) => {
      if (currentEl.dataset.section === sectionEl.dataset.section) {
        sectionEl.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    })
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)
    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false
  }

  setVisibility (visible) {
    visible = this.preventScroll ? false : visible

    this.setAttribute('aria-hidden', !visible)
    document.body.classList.toggle(this.dataset.bodyClass, visible)
  }
}

if (!customElements.get('product-fixed-bar')) {
  customElements.define('product-fixed-bar', ProductFixedBar)
}
